import React from 'react';

interface IconProps {
  width?: number;
  height?: number;
  fill?: string;
  viewBox?: string;
  strokeWidth?: number;
}

const BoldFontIcon = ({
  width = 24,
  height = 24,
  viewBox = `0 0 24 24`,
  fill = '#09244B',
  strokeWidth = 1,
}: IconProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink">
      <g id="页面-1" fill="none" fillRule="evenodd">
        <g
          id="Editor"
          transform="translate(-192.000000, 0.000000)"
          fillRule="nonzero">
          <g id="bold_line" transform="translate(192.000000, 0.000000)">
            <path
              d="M24,0 L24,24 L0,24 L0,0 L24,0 Z M12.5934901,23.257841 L12.5819402,23.2595131 L12.5108777,23.2950439 L12.4918791,23.2987469 L12.4918791,23.2987469 L12.4767152,23.2950439 L12.4056548,23.2595131 C12.3958229,23.2563662 12.3870493,23.2590235 12.3821421,23.2649074 L12.3780323,23.275831 L12.360941,23.7031097 L12.3658947,23.7234994 L12.3769048,23.7357139 L12.4804777,23.8096931 L12.4953491,23.8136134 L12.4953491,23.8136134 L12.5071152,23.8096931 L12.6106902,23.7357139 L12.6232938,23.7196733 L12.6232938,23.7196733 L12.6266527,23.7031097 L12.609561,23.275831 C12.6075724,23.2657013 12.6010112,23.2592993 12.5934901,23.257841 L12.5934901,23.257841 Z M12.8583906,23.1452862 L12.8445485,23.1473072 L12.6598443,23.2396597 L12.6498822,23.2499052 L12.6498822,23.2499052 L12.6471943,23.2611114 L12.6650943,23.6906389 L12.6699349,23.7034178 L12.6699349,23.7034178 L12.678386,23.7104931 L12.8793402,23.8032389 C12.8914285,23.8068999 12.9022333,23.8029875 12.9078286,23.7952264 L12.9118235,23.7811639 L12.8776777,23.1665331 C12.8752882,23.1545897 12.8674102,23.1470016 12.8583906,23.1452862 L12.8583906,23.1452862 Z M12.1430473,23.1473072 C12.1332178,23.1423925 12.1221763,23.1452606 12.1156365,23.1525954 L12.1099173,23.1665331 L12.0757714,23.7811639 C12.0751323,23.7926639 12.0828099,23.8018602 12.0926481,23.8045676 L12.108256,23.8032389 L12.3092106,23.7104931 L12.3186497,23.7024347 L12.3186497,23.7024347 L12.3225043,23.6906389 L12.340401,23.2611114 L12.337245,23.2485176 L12.337245,23.2485176 L12.3277531,23.2396597 L12.1430473,23.1473072 Z"
              id="MingCute"
              fillRule="nonzero"></path>
            <path
              d="M13,3 C15.7614,3 18,5.23858 18,8 C18,9.43071 17.3991,10.7211 16.4359,11.6325 C17.9657,12.4875 19,14.123 19,16 C19,18.6887316 16.8776708,20.8818169 14.2168878,20.9953804 L14,21 L6.1,21 C5.533,21 5.06617778,20.5709778 5.00645481,20.0198548 L5,19.9 L5,4.1 C5,3.53299067 5.42901351,3.06617653 5.98014344,3.00645469 L6.1,3 L13,3 Z M14,13 L7,13 L7,19 L14,19 C15.6569,19 17,17.6569 17,16 C17,14.3431 15.6569,13 14,13 Z M13,5 L7,5 L7,11 L13,11 C14.6569,11 16,9.65685 16,8 C16,6.34315 14.6569,5 13,5 Z"
              id="形状"
              fill={fill}
              stroke={fill}
              strokeWidth={strokeWidth}></path>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default BoldFontIcon;
